/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate your Body Mass Index from your height and weight, in metric or imperial units, and see which category it falls into.`)
};

const es_bmi_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula tu Índice de Masa Corporal a partir de tu altura y peso, en unidades métricas o imperiales, y ve en qué categoría cae.`)
};

const de_bmi_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechnen Sie Ihren Body-Mass-Index aus Ihrer Größe und Gewicht, in metrischen oder kaiserlichen Einheiten, und sehen Sie, in welche Kategorie er fällt.`)
};

const nl_bmi_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken uw Body Mass Index van uw lengte en gewicht, in metrische of imperiale eenheden, en zie in welke categorie het valt.`)
};

const fr_bmi_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez votre indice de masse corporelle à partir de votre taille et votre poids, en unités métriques ou impériales, et voyez dans quelle catégorie il se situe.`)
};

const it_bmi_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola il tuo Indice di Massa Corporea dalla tua altezza e dal tuo peso, in unità metriche o imperiali, e vedi in quale categoria rientra.`)
};

const pt_br2_bmi_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule seu Índice de Massa Corporal a partir de sua altura e peso, em unidades métricas ou imperiais, e veja em qual categoria ele se encaixa.`)
};

const pt_bmi_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule o seu Índice de Massa Corporal a partir da sua altura e peso, em unidades métricas ou imperiais, e veja em que categoria cai.`)
};

const ja_bmi_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身長と体重からBMI（体格指数）を計算してください。メートル法またはインペリアル単位を使用でき、どのカテゴリに該当するかを確認できます。`)
};

const zh_bmi_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据您的身高和体重（公制或英制单位）计算身体质量指数，并查看其所属类别。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_hub_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_hub_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_hub_intro", locale)
	if (locale === "en") return en_bmi_hub_intro(inputs)
	if (locale === "es") return es_bmi_hub_intro(inputs)
	if (locale === "de") return de_bmi_hub_intro(inputs)
	if (locale === "nl") return nl_bmi_hub_intro(inputs)
	if (locale === "fr") return fr_bmi_hub_intro(inputs)
	if (locale === "it") return it_bmi_hub_intro(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_hub_intro(inputs)
	if (locale === "pt") return pt_bmi_hub_intro(inputs)
	if (locale === "ja") return ja_bmi_hub_intro(inputs)
	return zh_bmi_hub_intro(inputs)
};